var op = require('./op')
var config = require('@sb/config')

var { unixSec } = require('./time.js')

function parseJSON (str) {
	try {
		return parse(str)
	} catch (e) {}
}

function isValidLanguageCode (code) {
	const allowLanguages = ['en', 'vi', 'en-US', 'vi-VN']
	return size(code) > 0 && allowLanguages.indexOf(code) >= 0
}

// convoOfEv extracts the ID of the conversation
// that event is sent to
function convoOfEv (ev) {
	if (!ev) return ''
	if (ev._convoid) return ev._convoid
	switch (ev.type) {
	case 'conversation_state_updated':
	case 'conversation_joined':
	case 'conversation_invited':
	case 'conversation_left':
	case 'conversation_tagged':
	case 'conversation_untagged':
	case 'conversation_typing':
	case 'conversation_rating_requested':
	case 'conversation_rated':
		return op.get(ev, 'data.conversation.id')
	case 'message_sent':
	case 'message_updated':
	case 'message_pong':
		return op.get(ev, 'data.message.conversation_id')
	case 'ticket_updated':
		return op.get(ev, 'data.ticket.conversation_id')
	default:
		return ''
	}
}

// convoKeyOfEv extracts the key of the conversation
// that event is sent to
function convoKeyOfEv (ev) {
	if (!ev) return ''
	if (ev._key) return ev._key
	switch (ev.type) {
	case 'conversation_state_updated':
	case 'conversation_joined':
	case 'conversation_invited':
	case 'conversation_left':
	case 'conversation_tagged':
	case 'conversation_untagged':
	case 'conversation_typing':
	case 'conversation_rating_requested':
	case 'conversation_rated':
		return op.get(ev, 'data.conversation._key')
	case 'message_sent':
	case 'message_updated':
	case 'message_pong':
		return op.get(ev, 'data.message._conversation_key')
	case 'ticket_updated':
		return op.get(ev, 'data.ticket._conversation_key')
	default:
		return ''
	}
}

function convoToEv (convoid, ev) {
	if (!ev) return ''
	switch (ev.type) {
	case 'conversation_state_updated':
	case 'conversation_joined':
	case 'conversation_invited':
	case 'conversation_left':
	case 'conversation_tagged':
	case 'conversation_untagged':
	case 'conversation_typing':
	case 'conversation_rating_requested':
	case 'conversation_rated':
		return op.set(ev, 'data.conversation.id', convoid)
	case 'message_sent':
	case 'message_updated':
	case 'message_pong':
		return op.set(ev, 'data.message.conversation_id', convoid)
	case 'ticket_updated':
		return op.set(ev, 'data.ticket.conversation_id', convoid)
	default:
		return ''
	}
}

function convoKeyToEv (convoKey, ev) {
	if (!ev) return ''
	switch (ev.type) {
	case 'conversation_state_updated':
	case 'conversation_joined':
	case 'conversation_invited':
	case 'conversation_left':
	case 'conversation_tagged':
	case 'conversation_untagged':
	case 'conversation_typing':
	case 'conversation_rating_requested':
	case 'conversation_rated':
		return op.set(ev, 'data.conversation._key', convoKey)
	case 'message_sent':
	case 'message_updated':
	case 'message_pong':
		return op.set(ev, 'data.message._conversation_key', convoKey)
	case 'ticket_updated':
		return op.set(ev, 'data.ticket._conversation_key', convoKey)
	default:
		return ''
	}
}

function setMsgField (ev, key, value) {
	var fields = op.get(ev, 'data.message.fields') || []
	fields.push({ key: key, value: stringify(value) })
	op.set(ev, 'data.message.fields', fields)
}

function getMsgField (ev, fieldName) {
	var fields = op.get(ev, 'data.message.fields')
	if (size(fields) === 0) return undefined
	let f = fields.find(f => f.key === fieldName)
	try {
		if (f) return parse(f.value)
		return undefined
	} catch (e) {}
}

function isPrimitive (test) {
	return test !== Object(test)
}

function cloneDeep (p) {
	if (isPrimitive(p)) return p
	var s = stringify(p) // stringify(()=>"") returns undefined
	if (s === undefined) return
	return parse(s)
}

function randomString (len) {
	var str = ''
	if (!len || len < 1) len = 10
	var asciiKey
	for (var i = 0; i < len; i++) {
		asciiKey = Math.floor(Math.random() * 25 + 97)
		str += String.fromCharCode(asciiKey)
	}
	return str
}

// tells whether an event can be combined with other same kind events into
// a summary event
// Eg: We can combine 3 events (A tags #a), (A tags #b), (A tags #c)
// into (A tags #a, #b and #c)
function isCombineEvent (ev) {
	return (
		ev.type === 'conversation_tagged' ||
		ev.type === 'conversation_untagged' ||
		ev.type === 'conversation_joined' ||
		ev.type === 'conversation_left'
	)
}

function visibleEvent (ev) {
	return (
		ev.type === 'conversation_tagged' ||
		ev.type === 'conversation_untagged' ||
		ev.type === 'conversation_joined' ||
		ev.type === 'conversation_left' ||
		ev.type === 'message_sent' ||
		ev.type === 'conversation_state_updated'
	)
}

function convertMessageEvent (events, i) {
	var event = events && events[i]
	if (!event) return

	var prevEvent = {}
	if (i > 0) prevEvent = events[i - 1]
	if (event.type === 'message_sent') {
		event.mode = 'lead'
		if (prevEvent.type === 'message_sent' && op.get(prevEvent, 'by.id') === op.get(event, 'by.id')) {
			event.mode = 'follow'
		}
		event.show_time = unixSec(event.created) - unixSec(prevEvent.created) > 600 // 10 mins
		return
	}

	if (!isCombineEvent(event)) return
	var nextEvent = {}
	if (i < events.length - 1) nextEvent = events[i + 1]
	event.mode = nextEvent.type === event.type ? 'hide' : 'combine'
}

// should call this function if you deleted event at index i-1 or appended a event at i
function convertUpdatedOrDeletedMessageEvent (events, i) {
	events = filter(
		events,
		ev => ev.type !== 'message_pong' && ev.type !== 'conversation_typing' && ev.type !== 'conversation_invited',
	)
	each(events, (_, j) => convertMessageEvent(events, j))
}

function mapize (arr, path) {
	arr = arr || []
	var map = {}
	each(arr, a => {
		map[op.get(a, path)] = a
	})
	return map
}

function mapizeDeep (arr, path) {
	arr = arr || []
	var map = {}
	each(arr, a => {
		map[op.get(a, path)] = parse(stringify(a))
	})
	return map
}

function toMap (arr, converter) {
	arr = arr || []
	var map = {}
	each(arr, a => {
		var obj = converter(a)
		map[obj.key] = obj.value
	})
	return map
}

function filter (collection, predicate) {
	if (!collection) return []
	if (!predicate) return collection

	var out = []
	if (Array.isArray(collection)) {
		for (let i = 0; i < collection.length; i++) {
			if (predicate(collection[i], i)) out.push(collection[i])
		}
		return out
	}

	if (typeof collection === 'object') {
		var keys = Object.keys(collection)
		for (let i = 0; i < keys.length; i++) {
			var k = keys[i]
			if (predicate(collection[k], k)) out.push(collection[k])
		}
		return out
	}

	return out
}

function includes (collection, value) {
	if (!collection) return false

	var isString = typeof collection === 'string' || collection instanceof String
	if (Array.isArray(collection) || isString) return collection.includes(value)
	return false
}

function map (collection, predicate) {
	if (!collection) return []
	if (!predicate) return collection

	var out = []
	if (Array.isArray(collection)) {
		for (let i = 0; i < collection.length; i++) {
			out.push(predicate(collection[i], i))
		}
		return out
	}

	if (typeof collection === 'object') {
		var keys = Object.keys(collection)
		for (let i = 0; i < keys.length; i++) {
			var k = keys[i]
			out.push(predicate(collection[k], k))
		}
		return out
	}

	return out
}

function each (collection, predicate) {
	return map(collection, predicate)
}

function usersOfConvo (convo) {
	if (!convo) return []
	return map(
		filter(convo.members, m => m.type === 'user'),
		m => m.id,
	)
}

function isConvoSeen (memberid, events) {
	if (!events) return true
	if (size(events) === 0) return true

	// find the last message send
	events = filter(events, ev => ev.type === 'message_sent')
	var lastmsgsent = events[size(events) - 1]
	if (!lastmsgsent) return true

	// if last message is sent by the member, we assume that
	// she already seen above messages
	if (op.get(lastmsgsent, 'by.id') === memberid) return true

	// looking seen info in pong
	let pongs = op.get(lastmsgsent, 'data.message.pongs', [])
	return !!find(pongs, pong => pong.type === 'seen' && pong.member_id === memberid)
}

function agentsOfConvo (convo, botIncluded) {
	if (!convo) return []
	return map(
		filter(convo.members, m => {
			if (botIncluded) return m.type === 'agent' || m.type === 'bot'
			return m.type === 'agent'
		}),
		m => m.id,
	)
}

// example url:
// content://media/external/images/media/37602
// https://subiz.com?a=4
// http://app.subiz.net/api
function isURL (str) {
	var pattern = new RegExp(
		'^((https?|content):\\/\\/)?' + // protocol
		'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
		'((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
		'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
		'(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
			'(\\#[-a-z\\d_]*)?$',
		'i',
	) // fragment locator
	return pattern.test(str)
}

function log () {
	const debug = getUrlParameter(window.location.search, '__sbdebug') || ''
	if (debug !== 'yes') return
	window.console.log(...arguments)
}

function startsWith (s, i) {
	return ((s || '') + '').startsWith(i)
}

function truncate (s, length, omission, separator) {
	length = length || 30
	omission = omission || '...'

	s = s || ''

	if (length >= s.length) return s

	let end = length - (omission.length || 0)
	if (end < 1) return omission

	let result = s.slice(0, end)

	if (separator === undefined) return result + omission

	if (s.indexOf(separator, end) !== end) {
		const index = result.lastIndexOf(separator)
		if (index > -1) result = result.slice(0, index)
	}
	return result + omission
}

function size (o) {
	if (!o) return 0
	if (o.length !== undefined) return o.length
	return Object.keys(o).length
}

function trim (s, suffix) {
	s = ((s || '') + '').replace(new RegExp((suffix || ' ') + '*$'), '')
	return trimStart(s, suffix)
}

function trimStart (s, prefix) {
	s = (s || '') + ''
	while (s.charAt(0) === prefix) s = s.substr(1)
	return s
}

// Returns a function, that, when invoked, will only be triggered at most once
// during a given window of time. Normally, the throttled function will run
// as much as it can, without ever going more than once per `wait` duration;
// but if you'd like to disable the execution on the leading edge, pass
// `{leading: false}`. To disable execution on the trailing edge, ditto.
function throttle (func, wait, options) {
	var context, args, result
	var timeout = null
	var previous = 0
	if (!options) options = {}
	var later = function () {
		previous = options.leading === false ? 0 : new Date().getTime()
		timeout = null
		result = func.apply(context, args)
		if (!timeout) context = args = null
	}
	return function () {
		var now = new Date().getTime()
		if (!previous && options.leading === false) previous = now
		var remaining = wait - (now - previous)
		context = this
		args = arguments
		if (remaining <= 0 || remaining > wait) {
			if (timeout) {
				clearTimeout(timeout)
				timeout = null
			}
			previous = now
			result = func.apply(context, args)
			if (!timeout) context = args = null
		} else if (!timeout && options.trailing !== false) {
			timeout = setTimeout(later, remaining)
		}
		return result
	}
}

function debounce (func, wait, immediate) {
	// 'private' variable for instance
	// The returned function will be able to reference this due to closure.
	// Each call to the returned function will share this common timer.
	var timeout

	// Calling debounce returns a new anonymous function
	return function () {
		// reference the context and args for the setTimeout function
		var context = this
		var args = arguments

		// Should the function be called now? If immediate is true
		//   and not already in a timeout then the answer is: Yes
		var callNow = immediate && !timeout

		// This is the basic debounce behaviour where you can call this
		//   function several times, but it will only execute once
		//   [before or after imposing a delay].
		//   Each time the returned function is called, the timer starts over.
		clearTimeout(timeout)

		// Set the new timeout
		timeout = setTimeout(function () {
			// Inside the timeout function, clear the timeout variable
			// which will let the next execution run when in 'immediate' mode
			timeout = null

			// Check if the function already ran with the immediate flag
			if (!immediate) {
				// Call the original function with apply
				// apply lets you define the 'this' object as well as the arguments
				//    (both captured before setTimeout)
				func.apply(context, args)
			}
		}, wait)

		// Immediate mode and no wait timer? Execute the function..
		if (callNow) func.apply(context, args)
	}
}

function find (collection, f) {
	if (!collection) return undefined
	return collection[findIndex(collection, f)]
}

function findIndex (collection, f) {
	if (!collection) return -1
	if (!f) return -1

	if (Array.isArray(collection)) {
		for (let i = 0; i < collection.length; i++) {
			if (f(collection[i], i)) return i
		}
		return -1
	}

	if (typeof collection === 'object') {
		var keys = Object.keys(collection)
		for (let i = 0; i < keys.length; i++) {
			var k = keys[i]
			if (f(collection[k], k)) return k
		}
	}
	return -1
}

function orderBy (a, k, d) {
	var clone = []
	each(a, v => clone.push(v))
	clone.sort((i, j) => {
		if (i[k] === j[k]) return 0
		var r = i[k] < j[k] ? -1 : 1
		return d === 'desc' ? -r : r
	})
	return clone
}

function getIntegrationId (accid) {
	return `${accid}.subizv4.subikon`
}

function isEmail (email) {
	var re = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i // eslint-disable-line
	return re.test(String(email).toLowerCase())
}

function getUrlParameter (urlPath = window.location.search, name) {
	name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
	var regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
	var results = regex.exec(urlPath)
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

function capitalize (value) {
	if (!value) return ''
	value = value.toString()
	return value.charAt(0).toUpperCase() + value.slice(1)
}

function last (array) {
	var length = array == null ? 0 : array.length
	return length ? array[length - 1] : undefined
}

function backwardCompatibleEv (ev, user) {
	if (op.get(ev, 'type') === 'message_sent') {
		var attachments = op.get(ev, 'data.message.attachments', [])

		// filter out empty attachment
		attachments = filter(attachments, att => !!att)
		var addedforms = []
		each(attachments, att => {
			if (att.type !== 'button') return

			// remove widget ask contact button
			att.buttons = filter(att.buttons, btn => {
				if (!btn) return false
				if (btn.type !== 'widget_ask_contact_info_button') return true
				addedforms.push({
					type: 'ask_info_form',
					form: {
						title: btn.title,
						fields: [
							{
								input_type: 'text',
								title: 'Name',
								name: 'fullname',
								default_answer: stringify(getUserAttr(user, 'fullname', 'text')),
								is_required: true,
							},
							{
								input_type: 'text',
								title: 'Email',
								name: 'emails',
								default_answer: stringify(getUserAttr(user, 'emails', 'text')),
								is_required: true,
							},
							{
								input_type: 'text',
								title: 'Phone',
								name: 'phones',
								default_answer: stringify(getUserAttr(user, 'phones', 'text')),
								is_required: true,
							},
						],
					},
				})
				return false
			})
		})

		attachments = attachments.concat(addedforms)
		if (size(attachments) > 0) op.set(ev, 'data.message.attachments', attachments)
	}
}

function getAgentDisplayName (account, agent) {
	return op.get(agent, 'fullname') || op.get(agent, 'email') || op.get(account, 'name') || 'Agent'
}

function isUserBanned (user) {
	return getUserAttr(user, 'is_ban', 'boolean')
}

function setUserAttr (user, attr) {
	if (!user) return
	if (!op.get(attr, 'key')) return

	user.attributes = user.attributes || []
	var index = findIndex(user.attributes, a => a.key === attr.key)
	if (index === -1) {
		user.attributes.push(attr)
		return
	}

	user.attributes[index] = attr
}

function getUserAttr (user, key, type) {
	if (!user || !user.attributes) return
	let value
	each(user.attributes, attr => {
		if (attr.key !== key) return

		if (type === 'datetime') value = attr.datetime
		if (type === 'boolean') value = attr.boolean
		if (type === 'number') value = attr.number
		if (type === 'text') value = attr.text
		if (type === 'list') value = attr.list
	})
	return value
}

function replaceFileUrl (src) {
	if (!src) return ''
	if (!startsWith(src, 'http://') && !startsWith(src, 'https://') && !startsWith(src, '//')) {
		src = trim(config.FileURL, '/') + '/' + trimStart(src, '/')
	}

	let url = new URL(src)
	if (url.host.endsWith('.subiz.com')) {
		let fileurl = new URL(config.FileURL)
		url.host = fileurl.host
		return url.toString()
	}

	return src
}

var stringify = JSON.stringify
var parse = JSON.parse

function jsonTest () {
	var testobj = { a: ['1', 2] }
	var teststr = `{"a":["1",2]}`
	if (JSON.stringify(testobj) === teststr) {
		var outobj = JSON.parse(teststr)
		if (outobj.a && outobj.a[0] === '1' && outobj.a[1] === 2) return // correct built-in JSON
	}

	// DANGER: may break client website
	// Prototype is a framework which override default JSON.stringify, we must restore the original
	// see https://stackoverflow.com/questions/710586/json-stringify-array-bizarreness-with-prototype-js
	// pacisoft.com is an example
	if (window.Prototype) {
		delete Object.prototype.toJSON
		delete Array.prototype.toJSON
		delete Hash.prototype.toJSON
		delete String.prototype.toJSON
	}

	if (JSON.decode) parse = JSON.decode
	if (JSON.encode) stringify = JSON.encode
}

jsonTest()

module.exports = {
	parseJSON,
	isValidLanguageCode,
	log,
	cloneDeep,
	randomString,
	toMap,
	convertMessageEvent,
	convertUpdatedOrDeletedMessageEvent,
	convoOfEv,
	convoKeyOfEv,
	mapize,
	mapizeDeep,
	usersOfConvo,
	convoToEv,
	convoKeyToEv,
	getMsgField,
	setMsgField,
	isURL,
	size,
	startsWith,
	trimStart,
	trim,
	truncate,
	debounce,
	throttle,
	filter,
	map,
	each,
	includes,
	find,
	findIndex,
	orderBy,
	getIntegrationId,
	isEmail,
	capitalize,
	agentsOfConvo,
	getUrlParameter,
	last,
	isConvoSeen,
	backwardCompatibleEv,
	getUserAttr,
	getAgentDisplayName,
	setUserAttr,
	isUserBanned,
	stringify,
	parse,
	replaceFileUrl,
}
